// import { useApiForm } from '../api-form'
import { useApiList } from '../api-list'
import { urlArgs } from '../state'

export const useApiListHeatmapSeries = args => useApiList(process.env.REACT_APP_API_HEATMAP, `api/v1/series${urlArgs(args)}`)
export const useApiListHeatmapNodeSession = args => useApiList(process.env.REACT_APP_API_HEATMAP, `api/v1/node-session${urlArgs(args)}`)
export const useApiListHeatmapUserSession = args => useApiList(process.env.REACT_APP_API_HEATMAP, `api/v1/user-session${urlArgs(args)}`)
export const useApiListHeatmapSessionQuery = args => useApiList(process.env.REACT_APP_API_HEATMAP, `api/v1/session-query${urlArgs(args)}`)
